import { Fragment } from "react";

import useRefundTool from "./UseRefundTool";

import RefundToolSearchForm from "./components/forms/RefundToolSearchForm";
import RefundToolFormGrid from "./components/grids/RefundToolFormGrid";

import Headings from "@usas/ui-web/components/headings/Headings";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import Constants from "@usas/ui-web/utils/Constants";

const RefundTool = () => {
  const {
    isLoading,
    transactionObj,
    refundErrorState,
    onSearchFormSubmit,
    onGridFormSubmit,
    onClearSearchClicked,
    onCloseErrorPopupClicked
  } = useRefundTool();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Payments Admin Refund Tool</Headings.H3>
        </div>
      </div>
      <RefundToolSearchForm onSubmitFormCallback={onSearchFormSubmit} onClearSearchClicked={onClearSearchClicked} />
      {transactionObj &&
        <RefundToolFormGrid transactionObj={transactionObj} onSubmitFormCallback={onGridFormSubmit} />
      }
      {refundErrorState.isError === true
        ? (
          <PopUpModal
            widthPct={90}
            maxWidth={720}
            title={'Error...'}
            displayPopUp={true}
            onModalCanceled={onCloseErrorPopupClicked}>
            <div className="row">
              <div className="col-xs-12">
                <p>{refundErrorState.errorMessage}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 usas-extra-top-margin">
                <SecondaryButton type="button" onClick={onCloseErrorPopupClicked}>Close</SecondaryButton>
              </div>
            </div>
          </PopUpModal>
        ) : (
          <PopUpModal
            widthPct={50}
            maxWidth={250}
            title={Constants.LOADING_MSG}
            displayPopUp={isLoading} />
        )
      }
    </Fragment>
  );
};

export default RefundTool;